module.exports = __webpack_public_path__ + "img/IMG-20200223-WA0246.5549fc21.jpg";